module.exports = __webpack_public_path__ + "static/media/IMG-4.53c591e4.jpg";